import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { WarehouseAddress, WarehouseRecord } from '@/types/warehouse';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export type WarehouseCreate = {
  name: string;
  fulfillment_provider_id: number;
  inventory_tracking: string;
  type: string;
  active: boolean;
  respect_allocations: boolean;
  address: { [Key in keyof WarehouseAddress]: string };
};

export const createWarehouse = async (
  scope: RequestScope,
  { data }: { data: WarehouseCreate },
  options: WriteRequestOptions
): Promise<EndpointResponse<WarehouseRecord>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<WarehouseRecord>>('warehouse', data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
